import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

const stripePromise = loadStripe(
  "pk_live_51HPDRdHciKBv1ntWpCT88WM0Y9LdAahmcDIu63bogk4I1ErMAhKHl10ICtJTeJqRtxUXuGwiS8gGQyHyLa9iN1am00IPUlJ8MT"
);

ReactDOM.render(
  <React.StrictMode>
    {/* <div>
      FRCA Reveal is currently under maintenance. We apologise for this
      inconvenience. Refer to @FRCA_reveal on Twitter for updates
    </div> */}
    <Elements stripe={stripePromise}>
      <App />
    </Elements>
  </React.StrictMode>,
  document.getElementById("root")
);
